import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
interface StyledBoxProps {
  layoutHeight: number;
  smLayoutHeight: number;
}
export const StyledBox = styled(Box)<StyledBoxProps>(
  ({ theme, layoutHeight, smLayoutHeight }) => ({
    '& .BDVBGContainer': {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      zIndex: 0,
      height: '100%',
      maxHeight: theme.typography.pxToRem(826),
      opacity: 0.7,
      '&:after': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: '80%',
        zIndex: 1,
        background: `linear-gradient(to top, ${theme.palette.background.primary} 0%, transparent 100%)`,
      },
    },
    '& .EDContentContainer': {
      position: 'relative',
      zIndex: 2,
      paddingTop: `calc(${theme.spacing(layoutHeight)} + ${theme.spacing(3)})`,
      [theme.breakpoints.down('md')]: {
        paddingTop: `calc(${theme.spacing(smLayoutHeight)} + ${theme.spacing(
          1,
        )})`,
      },
    },
    '& .EDVMapSectionContainer': {
      margin: theme.spacing(16, 0),
      [theme.breakpoints.down('lg')]: {
        margin: theme.spacing(10, 0),
      },
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(6, 0),
      },
    },
    '& .DVBookBtnContainer': {
      [theme.breakpoints.up('lg')]: {
        display: 'none',
      },
      position: 'sticky',
      bottom: '0',
      left: '0',
      width: '100%',
      zIndex: '2',
      borderRadius: 0,
      padding: theme.spacing(1),
      borderTop: `1px solid ${theme.palette.divider[7]}`,
      background: theme.palette.secondary.main,
      backdropFilter: `blur(${theme.spacing(1)})`,
    },
    '& .DVBookBtn': {
      padding: theme.spacing(1.75, 2),
      fontSize: theme.spacing(2),
      fontWeight: 600,
    },
    '& .EDVWidgetContainer': {
      padding: theme.spacing(3, 1.5),
      borderRadius: theme.spacing(1),
      border: `1px solid ${theme.palette.divider[7]}`,
      background: theme.palette.secondary.main,
      backdropFilter: `blur(${theme.spacing(1)})`,
      [theme.breakpoints.up('lg')]: {
        marginTop: theme.spacing(10),
        position: 'sticky',
        top: `calc(${theme.spacing(layoutHeight)} + ${theme.spacing(0.5)})`,
      },
    },
    '& .EDVMobileWidgetContainer': {
      borderTop: `1px solid ${theme.palette.divider[7]}`,
      padding: theme.spacing(10, 0),
      marginTop: theme.spacing(0),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(6, 0),
      },
    },
  }),
);
export default StyledBox;
